// extracted by mini-css-extract-plugin
module.exports = {"vPrimary1":"#00a8e2","vHoverTransition":".1s ease","showAll":"StoreOrderPickup_showAll__3Ddla","modalBody":"StoreOrderPickup_modalBody__bo4ZL"};